import axios from "axios";
import {
  GET_CUSTOM_FORM,
  PUT_STATUS_CUSTOM_FORM,
  POST_CUSTOM_FORM,
  GET_CUSTOM_FORM_DETAILS,
  PUT_CUSTOM_FORM_ORDER,
} from "..";
import {
  BYTE_WEB_DELETE_FILE,
  BYTE_WEB_FILE_UPLOAD,
} from "../../../../apiConstants";

/**
 * get popup Dialog  data
 * @param {Parameters} paramObj
 * @returns
 */
export const getCustomForm = (paramObj) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${GET_CUSTOM_FORM}`, {
    headers: { Authorization: jwt_token },
    params: paramObj,
  });
};

/**
 * enable-disable packages
 * @param {body} body
 * @returns
 */
export const updateStatus = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_STATUS_CUSTOM_FORM}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * create popup Dialog
 * @param {body} body
 * @returns
 */
export const postCustomForm = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${POST_CUSTOM_FORM}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * update popup Dialog
 * @param {body} body
 * @returns
 */
export const putUpdateCustomForm = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${POST_CUSTOM_FORM}`,
    body,
    {
      headers: { Authorization: jwt_token },
      params: { customFormId: body.customFormId },
    }
  );
};
/**
 * delete popup Dialog
 * @param {id} customFormId
 * @returns
 */
export const deleteCustomForm = (customFormId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.delete(`${process.env.REACT_APP_API_URL}${POST_CUSTOM_FORM}`, {
    headers: { Authorization: jwt_token },
    params: { customFormId },
  });
};

/**
 * get popup Dialog
 * @param {id} packageId
 * @returns
 */
export const getCustomFormDetails = (customFormId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${GET_CUSTOM_FORM_DETAILS}`,
    {
      headers: { Authorization: jwt_token },
      params: { customFormId },
    }
  );
};

/**
 * short order  popup Dialog
 * @param {body} updateOrder
 * @returns
 */
export const sort_order_CustomForm = (updateOrder) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_CUSTOM_FORM_ORDER}`,
    { updateOrder: updateOrder },
    {
      headers: { Authorization: jwt_token },
    }
  );
};
